module.exports = __webpack_public_path__ + "images/花筑pr长图_06-5.jpg?v=2262f760";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu1/花筑pr长图_06-5.jpg
 ** module id = 25
 ** module chunks = 1 2
 **/